var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Ink from 'react-ink';
import './Button.styles.scss';
import LoaderDots from './LoaderDots/LoaderDots';
import { Badge } from '../Badge';
var Button = function (_a) {
    var ariaLabel = _a.ariaLabel, badgeCounter = _a.badgeCounter, children = _a.children, disabled = _a.disabled, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, icon = _a.icon, _c = _a.iconPosition, iconPosition = _c === void 0 ? 'left' : _c, _d = _a.labelPosition, labelPosition = _d === void 0 ? 'right' : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, name = _a.name, onClick = _a.onClick, _f = _a.type, type = _f === void 0 ? 'button' : _f, _g = _a.variant, variant = _g === void 0 ? 'primary' : _g, rest = __rest(_a, ["ariaLabel", "badgeCounter", "children", "disabled", "fullWidth", "icon", "iconPosition", "labelPosition", "loading", "name", "onClick", "type", "variant"]);
    var allowedBadgeVariants = ['primary', 'secondary', 'tertiary'];
    var showBadge = !!badgeCounter && allowedBadgeVariants.includes(variant);
    var getButtonClassName = function () {
        var classList = ['hefesto-button'];
        classList.push("hefesto-button--".concat(variant));
        classList.push("hefesto-button__icon--".concat(iconPosition));
        if (labelPosition) {
            classList.push("hefesto-button__label--".concat(labelPosition));
        }
        if (loading) {
            classList.push('hefesto-button--loading');
        }
        if (disabled) {
            classList.push('hefesto-button--disabled');
        }
        if (fullWidth) {
            classList.push('hefesto-button--full-width');
        }
        return classList.join(' ');
    };
    var buttonClassName = getButtonClassName();
    var getIcon = function () {
        if (loading) {
            return _jsx(LoaderDots, {});
        }
        return icon !== null && icon !== void 0 ? icon : _jsx(_Fragment, {});
    };
    return (_jsx("button", __assign({ "aria-label": ariaLabel, className: buttonClassName, "data-testid": "hefesto-button", disabled: disabled, name: name, onClick: !loading ? onClick : undefined }, rest, { children: _jsxs("div", __assign({ className: "hefesto-button__container" }, { children: [_jsx(Ink, {}), iconPosition === 'left' && getIcon(), children && _jsx("span", __assign({ className: "hefesto-button__label" }, { children: children })), iconPosition === 'right' && !showBadge && getIcon(), showBadge && (_jsx(Badge, { type: "counter", value: badgeCounter, variant: variant === 'primary' ? 'light' : 'primary', plusPosition: "left" }))] })) })));
};
export default Button;
